var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", [
        _c("nav", { staticClass: "navbar navbar-default" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c(
              "form",
              {
                ref: "formRef",
                staticClass: "float-start d-flex align-items-center gap-1",
              },
              [
                _c(_setup.ReportMenu, {
                  attrs: { "reports-module": _setup.reportsModule },
                }),
                _vm._v(" "),
                _setup.formData.reportName === "relatedProducts"
                  ? [
                      _c(_setup.PrimaryCategoryFilter),
                      _vm._v(" "),
                      _c(_setup.DateRangeFilter, {
                        attrs: { "reports-module": _setup.reportsModule },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _setup.formData.reportName !== ""
                  ? _c(
                      "button",
                      {
                        staticClass: "ms-2 btn btn-primary btn-sm",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _setup.submitForm.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Go\n                    ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _setup.rows && _setup.rows.length
                  ? _c("span", { staticClass: "ms-2 text-nowrap" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_setup.formatNumber(_setup.rows.length)) +
                          " records found\n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _setup.isLoading
                  ? _c("span", { staticClass: "ms-2 ajax-spinner" }, [
                      _c("span", {
                        staticClass: "ajax-spinner-icon ajax-spinner-icon-sm",
                      }),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _setup.rows && _setup.rows.length
              ? _c(
                  "div",
                  { staticClass: "float-end" },
                  [
                    _c(
                      _setup.Button,
                      {
                        nativeOn: {
                          click: function ($event) {
                            return _setup.openPrintModal.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi-printer" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "visually-hidden" }, [
                          _vm._v("Print report"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      _setup.Button,
                      {
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _setup.downloadCSVData.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi-download" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "visually-hidden" }, [
                          _vm._v("Download CSV"),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _setup.rows && _setup.rows.length === 0
          ? _c("p", { staticClass: "mx-2 alert alert-warning" }, [
              _vm._v("\n            No records match your search.\n        "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _setup.error
          ? _c("p", {
              staticClass: "mx-2 alert alert-warning",
              domProps: { innerHTML: _vm._s(_setup.error) },
            })
          : _vm._e(),
        _vm._v(" "),
        _setup.rows && _setup.rows.length
          ? _c("div", { staticClass: "padding-sm table-wrapper" }, [
              _c(
                "table",
                { staticClass: "table table-condensed table-striped" },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      _vm._l(_setup.rows[0], function (value, heading) {
                        return _c(
                          "td",
                          {
                            key: "head-" + heading,
                            on: {
                              click: function ($event) {
                                return _setup.setSortBy(heading)
                              },
                            },
                          },
                          [
                            heading === _setup.sortBy
                              ? _c("span", {
                                  class: {
                                    "bi-chevron-up": _setup.sortDir === "asc",
                                    "bi-chevron-down":
                                      _setup.sortDir === "desc",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                        " +
                                _vm._s(heading) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_setup.sortedRows, function (row, rowIndex) {
                      return _c(
                        "tr",
                        { key: "row-" + rowIndex },
                        _vm._l(row, function (value, heading) {
                          return _c("td", {
                            key: "cell-" + heading,
                            domProps: { innerHTML: _vm._s(value) },
                          })
                        }),
                        0
                      )
                    }),
                    0
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _setup.rows
        ? _c(_setup.PrintReport, {
            ref: "toPrint",
            staticStyle: { display: "none" },
            attrs: {
              heading: _setup.reportLabel,
              rows: _setup.sortedRows,
              "start-date": _setup.startDate,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }